import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import LoginModal from './LoginModal';
import { getCurrentUser } from '../lib/auth';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const user = getCurrentUser();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Handle keyboard navigation
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      setIsMenuOpen(false);
    }
  };

  return (
    <nav 
      className="bg-white shadow-sm fixed w-full top-0 z-50"
      role="navigation"
      aria-label="Navigation principale"
    >
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex justify-between items-center h-16">
          <Logo />

          {/* Only show navigation menu for non-logged in users */}
          {!user && (
            <>
              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center space-x-8">
                <Link to="/" className="text-gray-700 hover:text-primary transition-colors">
                  Accueil
                </Link>
                <a href="#tarifs" className="text-gray-700 hover:text-primary transition-colors">
                  Tarifs
                </a>
                <a href="#blog" className="text-gray-700 hover:text-primary transition-colors">
                  Blog
                </a>
                <button
                  onClick={() => setIsLoginModalOpen(true)}
                  className="btn-primary"
                  aria-label="Commencer l'essai gratuit"
                >
                  Essai gratuit
                </button>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={toggleMenu}
                className="md:hidden text-gray-700 hover:text-primary transition-colors p-2"
                aria-expanded={isMenuOpen}
                aria-controls="mobile-menu"
                aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
              >
                {isMenuOpen ? (
                  <X className="w-6 h-6" aria-hidden="true" />
                ) : (
                  <Menu className="w-6 h-6" aria-hidden="true" />
                )}
              </button>
            </>
          )}
        </div>
      </div>

      {/* Mobile Menu - Only show for non-logged in users */}
      {!user && isMenuOpen && (
        <div 
          id="mobile-menu"
          ref={menuRef}
          className="md:hidden fixed inset-0 top-16 bg-white z-40"
          onKeyDown={handleKeyDown}
          role="dialog"
          aria-modal="true"
          aria-label="Menu mobile"
        >
          <div className="flex flex-col p-6 space-y-6">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-primary transition-colors text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <a 
              href="#tarifs" 
              className="text-gray-700 hover:text-primary transition-colors text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Tarifs
            </a>
            <a 
              href="#blog" 
              className="text-gray-700 hover:text-primary transition-colors text-lg"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </a>
            <button
              onClick={() => {
                setIsMenuOpen(false);
                setIsLoginModalOpen(true);
              }}
              className="btn-primary w-full text-center py-3"
              aria-label="Commencer l'essai gratuit"
            >
              Essai gratuit
            </button>
          </div>
        </div>
      )}

      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLoginSuccess={() => setIsLoginModalOpen(false)}
      />
    </nav>
  );
};

export default Navbar;